/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { Footer } from '@components/systems'
import { customerAuthStyle } from './customerAuth.style'

import { useAppSelector, useAppDispatch, customerAuthActions } from '@redux/index'
import { produce } from 'immer'
import { useNavigate } from 'react-router-dom'

/**
 * Login — Monolith(2안).
 *
 * 구 페이지의 흰 카드 + 블러 배경 사진 조합을 걷어냈다. DESIGN_SYSTEM §6.4 폼 규격 —
 * 중앙 정렬, 밑줄 입력, 블랙 CTA 하나. redux(customerAuth) 흐름은 그대로다.
 */
const MonolithCustomerLoginPage = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// hook
	const navigate = useNavigate()

	// redux state
	const loginErrorMessage: string = useAppSelector(
		state => state.customerAuth.loginErrorMessage,
	)

	// state
	const [account, setAccount] = React.useState({ email: '', password: '' })

	const onIdChange = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const str = e.target.value
			const newAccount = produce(account, draft => {
				draft.email = str
			})

			setAccount(newAccount)
		},
		[account],
	)

	const onPwChange = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const str = e.target.value
			const newAccount = produce(account, draft => {
				draft.password = str
			})

			setAccount(newAccount)
		},
		[account],
	)

	const onLoginClick = React.useCallback(() => {
		if (account.email !== '' && account.password !== '') {
			reduxDispatch(
				customerAuthActions.LOGIN({ email: account.email, password: account.password }),
			)
		} else {
			reduxDispatch(
				customerAuthActions.LOGIN_ERROR_MESSAGE(
					'Please check your login information again.',
				),
			)
		}
	}, [account])

	const onSubmit = (e: React.FormEvent) => {
		e.preventDefault()
		onLoginClick()
	}

	return (
		<View css={style}>
			<View className="mnWrap">
				<View className="mnAuthHeader">
					<h1 className="mnAuthTitle">Login</h1>
					<p className="mnAuthLede">Orders and account settings.</p>
				</View>

				<form className="mnAuthForm" onSubmit={onSubmit} noValidate>
					<View className="mnField">
						<label className="mnLabel" htmlFor="mnLoginEmail">
							Email
						</label>
						<input
							id="mnLoginEmail"
							type="email"
							className={`mnInput ${loginErrorMessage !== '' ? 'error' : ''}`}
							value={account.email}
							onChange={onIdChange}
							autoComplete="email"
						/>
					</View>

					<View className="mnField">
						<label className="mnLabel" htmlFor="mnLoginPassword">
							Password
						</label>
						<input
							id="mnLoginPassword"
							type="password"
							className={`mnInput ${loginErrorMessage !== '' ? 'error' : ''}`}
							onChange={onPwChange}
							autoComplete="current-password"
						/>
					</View>

					{loginErrorMessage !== '' && (
						<span className="mnError">{loginErrorMessage}</span>
					)}

					<View className="mnAuthAction">
						<button type="submit" className="mnCta mnAuthCta">
							Log in
						</button>
					</View>

					<View className="mnAuthLinks">
						<button
							type="button"
							className="mnAuthLink"
							onClick={() => navigate('/customer/join')}
						>
							Create an account
						</button>
						<span className="mnAuthLinkSep" aria-hidden="true" />
						<button
							type="button"
							className="mnAuthLink"
							onClick={() => navigate('/customer/forgot-password')}
						>
							Forgot password
						</button>
					</View>
				</form>
			</View>

			<Footer />
		</View>
	)
}

export default MonolithCustomerLoginPage

const style = css(customerAuthStyle)
